import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../../assets/icons/filter.svg'
import _imports_1 from '../../../../assets/icons/filter-light.svg'
import _imports_2 from '../../../../assets/aw-footer-logo.jpg'


const _hoisted_1 = { class: "report-template" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = {
  key: 0,
  class: "report-chart"
}
const _hoisted_4 = { class: "d-flex justify-end" }
const _hoisted_5 = { class: "benchmark-filter-menu-data-quality" }
const _hoisted_6 = { class: "ml-1" }
const _hoisted_7 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KeyStats = _resolveComponent("KeyStats")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_BenchmarkFilterTable = _resolveComponent("BenchmarkFilterTable")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_VFMIndustryCompareChart = _resolveComponent("VFMIndustryCompareChart")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "report-page-card",
      outlined: "",
      flat: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.fetchingDataQuality)
            ? (_openBlock(), _createBlock(_component_KeyStats, {
                key: 0,
                class: "mt-4",
                data: _ctx.metrics,
                tooltipVisibility: false
              }, null, 8, ["data"]))
            : _createCommentVNode("", true)
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "section" }, [
          _createElementVNode("div", { class: "section-title" }, [
            _createElementVNode("div", { class: "section-badge" }),
            _createTextVNode(" AgeWage Score Benchmarking ")
          ]),
          _createElementVNode("div", { class: "section-content" }, " AgeWage considers the internal rate of return (IRR) of an individual’s pension account as a good measure of saver’s investment experience as it includes the impact of all costs and charges as well as all returns on invested assets. AgeWage uses the Morningstar UK pension index as a benchmark for IRRs. By shadow-investing a saver’s contributions into this index, AgeWage creates a benchmark IRR and by means of an algorithm, converts the comparison of IRRs into an AgeWage score. "),
          _createElementVNode("div", { class: "section-content" }, " The AgeWage score rates each saver’s experience between 0 and 100 with a 50 score being an average experience. The Scheme’s score is the mathematical average of every member’s score and reflects the average experience of savers over their time in the scheme ")
        ], -1)),
        (!_ctx.fetchingBechmarkingReports && !_ctx.fetchingDataQuality && _ctx.data && _ctx.data.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_v_menu, {
                    modelValue: _ctx.filterIsVisible,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterIsVisible) = $event)),
                    "close-on-content-click": false,
                    "content-class": "benchmark-filter-menu-wrapper",
                    "max-width": "100%",
                    "min-width": "100%",
                    offset: "20",
                    transition: "slide-y-transition"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        class: ["filter-btn elevation-6 mt-0 mx-2", { 'is-active': _ctx.filtersAreApplied }],
                        "data-testid": "FilterBtn",
                        variant: "text"
                      }, props, { size: "small" }), {
                        default: _withCtx(() => [
                          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Filter", -1)),
                          _createElementVNode("div", _hoisted_6, [
                            (!_ctx.filtersAreApplied)
                              ? (_openBlock(), _createBlock(_component_v_img, {
                                  key: 0,
                                  class: "filter-icon",
                                  src: _imports_0
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.filtersAreApplied)
                              ? (_openBlock(), _createBlock(_component_v_img, {
                                  key: 1,
                                  class: "filter-icon",
                                  src: _imports_1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 16, ["class"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_BenchmarkFilterTable, {
                        dateFilters: true,
                        filters: _ctx.filters,
                        initFilters: _ctx.appliedFilters,
                        onApply: _cache[0] || (_cache[0] = (e) => _ctx.onFiltersApplied(e))
                      }, null, 8, ["filters", "initFilters"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              (_ctx.chartData)
                ? (_openBlock(), _createBlock(_component_VFMIndustryCompareChart, {
                    key: 0,
                    data: _ctx.chartData,
                    providerDataQuality: _ctx.providerDataQuality,
                    providerName: _ctx.providerName,
                    providerId: _ctx.providerId,
                    onExpandGraph: _ctx.expandGraph
                  }, null, 8, ["data", "providerDataQuality", "providerName", "providerId", "onExpandGraph"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _cache[3] || (_cache[3] = _createElementVNode("div", null, null, -1)),
          _createVNode(_component_v_img, {
            class: "footer-img",
            src: _imports_2
          })
        ])
      ]),
      _: 1
    })
  ]))
}